export default class AdminDietPlanUploads {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminDietPlanUploadsRoute, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminDietPlanUploadsRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminDietPlanUploadsRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminDietPlanUploadsRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminDietPlanUploadsRoute}/${id}`, payload, {})
  }

  upload(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminDietPlanUploadsRoute}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminDietPlanUploadsRoute}/${id}`, {})
  }
}
